import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import { H1, RichText } from 'components/typography';
import { TextBlockWrapper } from 'components/layout';
import Button from './Button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TopTitle = styled.p`
  text-transform: uppercase;
  color: ${({ theme }) => theme.palette.blueBase};
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: 0.16em;
  margin-bottom: 3.2rem;

  ${({ theme }) => theme.breakpoints.maxMobile} {
    font-size: 0.8rem;
    margin-bottom: 1.6rem;
  }
`;

const TitleButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 2.4rem;

  ${({ theme }) => theme.breakpoints.maxMobile} {
    margin-bottom: 1.6rem;
  }
`;

const Title = styled(H1)`
  font-size: ${({ titleSize }) => titleSize || null};
  max-width: ${({ titleMaxWidth }) => titleMaxWidth || '55.2rem'};
  margin-bottom: ${({ titleMarginBottom }) => titleMarginBottom || null};
`;

const LinkWrapper = styled.div`
  ${({ theme }) => theme.breakpoints.maxMobile} {
    display: none;
  }
`;

const SectionTitle = ({
  subTitle,
  title,
  titleSize,
  titleMaxWidth,
  titleMarginBottom,
  description,
  paragraphBlack,
  wideTextBlock,
  paragraphSize,
  className,
  link,
}) => (
  <Container className={className}>
    {subTitle && <TopTitle>{subTitle}</TopTitle>}
    {title && (
      <TitleButtonWrapper>
        <Title
          titleSize={titleSize}
          titleMaxWidth={titleMaxWidth}
          titleMarginBottom={titleMarginBottom}
        >
          {title}
        </Title>
        {link && (
          <LinkWrapper>
            <Button variant="secondary" as={Link} to={link.url}>
              {link.text}
            </Button>
          </LinkWrapper>
        )}
      </TitleButtonWrapper>
    )}
    {description && (
      <TextBlockWrapper isWide={wideTextBlock}>
        <RichText paragraphBlack={paragraphBlack} paragraphSize={paragraphSize}>
          {description}
        </RichText>
      </TextBlockWrapper>
    )}
  </Container>
);

export default SectionTitle;
